export default __webpack_public_path__ + "static/media/costo_personas.cea80ec0.jpg";